export const PSK_TOOLTIP = {
  title: 'Полная стоимость кредита',
  content:
    'По закону «О рекламе» № 38-ФЗ мы обязаны указывать полную стоимость кредита (ПСК) — сумму ваших реальных расходов по кредиту включая ставку, страховку и стоимость других доп. услуг. Значения ПСК получены из открытых источников. Итоговая процентная ставка и ПСК будут указаны в кредитном договоре и рассчитываются индивидуально',
};
